<template>
	<div>
		<button
			type="button"
			class="btn btn-icon-profile pt-0 mt-0"
			v-click-outside="hideContext" @click="toggleContext()" ref="dropdownContextProfile">
			<img :src="user && user.picture ? user.picture : ''" class="profile-avatar" alt="Grafias" v-if="user && user.picture !== ' ' && user && user.picture !== null" >
			<div v-if="user && user.picture === null || user && user.picture === ' '" class="thumbnail-profile-dropdown">
				<div
					:class="{'initial-profile-dropdown-client': roles[0].includes('client'),
							'initial-profile-dropdown-collab': roles[0].includes('collaborator'),
							'initial-profile-dropdown-finance': roles[0].includes('finance'),
							'initial-profile-dropdown-sa': roles.includes('super_admin')
						}"
				>{{ generateInitial(name) }}</div>
			</div>
			<ul  v-if="opened" class="pointer dropdown-context-profile-item text-left">
				<li class="text-white-context pl-4 pb-2 pt-2" v-if="!smallScreen && isApiAccesses && (apiAccesses && apiAccesses.total_remaining && apiAccesses.total_remaining === 'unlimited')">
					{{ $t('Limit Url Access') }} : {{ '∞'}}
				</li>
				<li class="text-white-context pl-4 pb-2 pt-2" v-if="!smallScreen && isApiAccesses && (apiAccesses && apiAccesses.total_remaining && apiAccesses.total_remaining !== 'unlimited')">
					{{ $t('Limit Url Access') }} : {{ apiAccesses && apiAccesses.total_remaining ? apiAccesses.total_remaining : 0 }}
				</li>
				<li @click="goTo('/settings?menu=general')" class="text-white-context pl-4 pb-2 pt-2" v-if="!smallScreen">
					<router-link to="/settings?menu=general" class="link-white-nodecor">{{ $t('Account Settings') }} </router-link>
				</li>
				<li v-if="user && !user.roles.includes('client')" type="button" class="text-white-context pl-4 pb-2 pt-2" @click="isShowMoreFeature = true">
					{{ $t('More Features') }}
				</li>
				<!-- <li class="text-white-context pl-4 pb-2 pt-2" @click="opened = false">
					<router-link to="/settings" class="link-white-nodecor">{{ $t('View My Profile') }}</router-link>
				</li> -->
				<li class="text-white-context pl-4 pb-2 pt-2" @click="changeRole" v-if="roles.length > 1 && !smallScreen">
					{{ $t('Change Role') }}
				</li>
				<a href="https://docs.grafiaslive.com" target="_blank" class="link-white-nodecor" v-if="!smallScreen">
					<li class="text-white-context pl-4 pb-2 pt-2">
					{{ $t('Documentation page') }}
					</li>
				</a>
				<li class="text-white-context pl-4 pb-2 pt-2" @click="updateProfile(isTourVisible)">
					<label v-show="!isTourVisible" >{{ $t('Show Onboarding window') }}</label>
					<label v-show="isTourVisible">{{ $t('Hide Onboarding window') }}</label>
				</li>
				<!-- <li class="text-white-context pl-4 pb-2 pt-2" @click="addFeedback" v-if="!smallScreen">
					<span class="text-white-context">{{ $t('Send Feedback or Bug Report') }}</span>
				</li> -->
				<a href=" https://grafiaslive.com/contact-us/" target="_blank" class="link-white-nodecor" v-if="!smallScreen">
					<li class="text-white-context pl-4 pb-2 pt-2">
					{{ $t('Contact Us') }}
					</li>
				</a>
				<!-- <li class="text-white-context pl-4 pb-2 pt-2">
					{{ $t('Version') }} {{appVersion}}
				</li> -->
				<li class="text-white-context pl-4 pb-2 pt-2" @click="credit" v-if="!smallScreen">
					{{ $t('Credits') }}
				</li>
				<li class="text-white-context pl-4 pb-2 pt-2" @click="goTo('/logout')">
					<router-link to="/logout" class="link-white-nodecor">{{ $t('Logout') }}</router-link>
				</li>
			</ul>
		</button>
		<!-- Modals Feedback-->
		<div class="modals">
			<!-- Form -->
			<modal-send-feedback
				@close="isFormVisible = false"
				v-if="isFormVisible"
			/>
			<modal-credit-user
				@close="isModalCreditVisible = false"
				v-if="isModalCreditVisible"
			/>
			<modal-change-role
				@close="isModalChangeRoleVisible = false"
				v-if="isModalChangeRoleVisible"
			/>
		</div>
		<!-- more features modal -->
		<modal
			size="small"
			@close="isShowMoreFeature = false"
			v-if="isShowMoreFeature"
			>
			<template slot="header">
				<span class="ml-1">{{ $t('More Features') }}</span>
			</template>
			<template slot="body">
				<div class="text-base">{{ $t('Your account will be converted as') }} <span class="text-primary">{{ $t('Free account') }}</span>, {{ $t('with basic features of Grafias, you can upgrade for more features in your subscription page') }}.</div>
			</template>
			<template slot="footer">
				<button type="submit" class="btn btn-submit btn-primary mt-4"
					:class="{ 'is-loading': isLoadingMoreFeature }" @click="changeToClientRole">
					{{ $t('Proceed') }}
				</button>
				<button type="submit" class="btn btn-default mt-4" @click="isShowMoreFeature = false">
					{{ $t('Cancel') }}
				</button>
			</template>
		</modal>
	</div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { mapGetters, mapActions } from 'vuex';
import { getAxiosErrorMessage, duplicateVar } from '@/lib/helper';
import Modal from '@/components/Modal.vue';
import ModalSendFeedback from '@/components/ModalSendFeedback.vue';
import ModalCreditUser from '@/components/ModalCreditUser.vue';
import ModalChangeRole from '@/components/ModalChangeRole.vue';
import authApi from '@/api/auth';
import userApi from '@/api/user';

export default {
	name: 'ProfileDropdown',
	components: {
		ModalSendFeedback,
		ModalCreditUser,
		ModalChangeRole,
		Modal,
	},
	data() {
		return {
			showDropdown: false,
			isFormVisible: false,
			isModalCreditVisible: false,
			isModalChangeRoleVisible: false,
			dataRoles: [],
			opened: false,
			colors: [
				'#FF0000',
				'#0000FF',
				'#00C03E',
			],
			smallScreen: false,
			isShowMoreFeature: false,
			isLoadingMoreFeature: false,
			isGetTokenFrill: false,
			// set settings user
			settings: null,
			isEnableAdvance: false,
			isEnableDummy: true,
			isEnableAllPreview: false,
			isEnableShowLogo: false,
			lastCategoryTemplate: 0,
			lastKeywordTemplate: '',
			lastCategoryGallery: 1,
			lastKeywordGallery: '',
		};
	},
	directives: {
		ClickOutside,
	},
	methods: {
		...mapActions({
			setUser: 'setUser',
		}),
		toggleContext() {
			this.opened = !this.opened;
		},
		hideContext() {
			this.opened = false;
		},
		addFeedback() {
			this.isGetTokenFrill = true;
			const callback = (response) => {
				const token = response.data;
				this.isGetTokenFrill = false;
				this.opened = false;
				window.open(`${token}`, '_blank');
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t('SSO failed'),
					text: message,
				});
				this.isGetTokenFrill = false;
			};
			userApi.frillToken(callback, errorCallback);
		},
		credit() {
			this.isModalCreditVisible = true;
			this.opened = false;
		},
		changeRole() {
			this.isModalChangeRoleVisible = true;
			this.opened = false;
		},
		// eslint-disable-next-line
		parseRoles() {
			if (this.roles) {
				this.dataRoles = JSON.parse(this.roles);
				return this.dataRoles;
			}
		},
		onClick(e) {
			const el = this.$refs.dropdownContextProfile;
			const target = e.target;
			if (e.target) {
				if ((el !== target) && !el.contains(target)) {
					this.opened = false;
				}
			}
		},
		goTo(link) {
			this.$router.push(link).catch(() => {});
		},
		generateInitial(name) {
			const words = name ? name.split(' ') : 'AN';
			let initial = words[0][0] !== undefined ? words[0][0] : 'AN';
			if (words.length > 1) {
				const firstCharacter = words[0][0] !== undefined ? words[0][0] : '';
				const secondCharacter = words[1][0] !== undefined ? words[1][0] : '';
				initial = `${firstCharacter}${secondCharacter}`;
			}
			this.setSettingsData();
			return initial;
		},
		onResizeWidth() {
			if (window.innerWidth <= 1024) {
				this.smallScreen = true;
			} else {
				this.smallScreen = false;
			}
		},
		changeToClientRole() {
			this.isLoadingMoreFeature = true;
			// eslint-disable-next-line
			const rolesArray = ["client", "collaborator"];
			const params = {
				roles: JSON.stringify(rolesArray),
			};
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
				this.setRole('client');
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: this.$t('Update features'),
					text: message,
				});
				this.isShowMoreFeature = false;
				this.isLoadingMoreFeature = true;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t('Update features'),
					text: message,
				});
				this.isLoadingMoreFeature = true;
			};
			authApi.updateProfile(params, callback, errorCallback);
		},
		setSettingsData() {
			// @TODO: catch variable user setting if setting is undefined
			const settings = JSON.parse(this.user.settings);
			if (settings) {
				const settingsString = this.user.settings;
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				this.isEnableAdvance = settings && settings.is_enable_advance_layout ? duplicateVar(settings.is_enable_advance_layout) : false;
				this.isEnableDummy = settings && settings.is_enable_dummy_item_data ? duplicateVar(settings.is_enable_dummy_item_data) : false;
				this.isEnableAllPreview = settings && settings.is_enable_all_preview ? duplicateVar(settings.is_enable_all_preview) : false;
				this.isEnableShowLogo = settings && settings.is_enable_show_logo ? duplicateVar(settings.is_enable_show_logo) : false;
				this.isShowTour = settings && settings.is_tour_visible ? duplicateVar(settings.is_tour_visible) : false;
				this.lastCategoryTemplate = settings && settings.last_category_template ? duplicateVar(settings.last_category_template) : 0;
				this.lastKeywordTemplate = settings && settings.last_keyword_template ? duplicateVar(settings.last_keyword_template) : '';
				this.lastCategoryGallery = settings && settings.last_category_gallery ? duplicateVar(settings.last_category_gallery) : 0;
				this.lastKeywordGallery = settings && settings.last_keyword_gallery ? duplicateVar(settings.last_keyword_gallery) : '';
				if (this.lastCategoryTemplate !== 0) {
					this.category = this.lastCategoryTemplate;
					this.categoryId = this.lastCategoryTemplate;
				} else {
					this.category = 'all';
				}
				if (this.lastKeywordTemplate) {
					this.keyword = this.lastKeywordTemplate;
				} else {
					this.keyword = '';
				}
			} else {
			// @TODO: catch variable user setting if setting is undefined
				const settingsString = this.user.settings;
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				this.isEnableAdvance = 0;
				this.isEnableDummy = 0;
				this.isEnableAllPreview = 0;
				this.isEnableShowLogo = 0;
				this.isShowTour = false;
				this.lastCategoryTemplate = 1;
				this.lastKeywordTemplate = '';
				this.lastCategoryGallery = 1;
				this.lastKeywordGallery = '';
			}
		},
		updateProfile(tour) {
			this.settings.is_enable_advance_layout = this.isEnableAdvance;
			this.settings.is_enable_dummy_item_data = this.isEnableDummy;
			this.settings.is_enable_all_preview = this.isEnableAllPreview;
			this.settings.is_enable_show_logo = this.isEnableShowLogo;
			this.settings.is_tour_visible = !tour;
			this.settings.last_category_template = this.lastCategoryTemplate;
			this.settings.last_keyword_template = this.lastKeywordTemplate;
			this.settings.last_category_gallery = this.lastCategoryGallery;
			this.settings.last_keyword_gallery = this.lastKeywordGallery;
			const paramsSettings = { settings: JSON.stringify(this.settings) };
			const layout = paramsSettings;
			const params = layout;
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
			};
			const errorCallback = () => {
			};
			authApi.updateProfile(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		appVersion() {
			return process.env.VUE_APP_VERSION;
		},
		roles() {
			return this.user && this.user.roles ? JSON.parse(this.user.roles) : '';
		},
		name() {
			return this.user && this.user.name ? this.user.name : '';
		},
		isTourVisible() {
			const settings = JSON.parse(this.user && this.user.settings ? this.user.settings : '');
			return settings && settings.is_tour_visible ? settings.is_tour_visible : '';
		},
		apiAccesses() {
			const userApiAccess = this.user && this.user.apiAccesses ? this.user.apiAccesses : null;
			console.log(userApiAccess);
			return userApiAccess;
		},
		isApiAccesses() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			const userSubscription = settings && settings.subscription ? settings.subscription : null;
			const apiAccessesSetting = userSubscription && userSubscription.api_access ? userSubscription.api_access : null;
			const isApiAccesses = apiAccessesSetting && apiAccessesSetting.is_enabled ? apiAccessesSetting.is_enabled : false;
			return isApiAccesses;
		},
	},
	watch: {
	},
	mounted() {
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
	},
	created() {
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
		window.addEventListener('contextmenu', this.onClick);
	},
	destroyed() {
		window.removeEventListener('contextmenu', this.onClick);
	},
};
</script>
<style lang="scss" scoped>
.thumbnail-profile-dropdown {
	padding-top: 2.8px;
	position: relative;
	height: 40px;
	width: 40px;
	text-align: center;
	.initial-profile-dropdown-sa {
		font-size: 1.3em;
		padding: 6.3px;
		height: 40px;
		width: 40px;
		margin: 0 auto;
		border-radius: 50%;
		background-color: #FF0000;
		color: #fff;
	}
	.initial-profile-dropdown-client {
		font-size: 1.3em;
		padding: 6.3px;
		height: 40px;
		width: 40px;
		margin: 0 auto;
		border-radius: 50%;
		background-color: #0000FF;
		color: #fff;
	}.initial-profile-dropdown-collab {
		font-size: 1.3em;
		padding: 6.3px;
		height: 40px;
		width: 40px;
		margin: 0 auto;
		border-radius: 50%;
		background-color: #00C03E;
		color: #fff;
	}
	.initial-profile-dropdown-finance {
		font-size: 1.3em;
		padding: 6.3px;
		height: 40px;
		width: 40px;
		margin: 0 auto;
		border-radius: 50%;
		background-color: orange;
		color: #fff;
	}
}
</style>
